import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ComboDetails } from 'src/app/models/commission/combo-details.model';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { MobileFeedModel } from 'src/app/models/commission/mobile-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { CommissionService } from 'src/app/service/commission.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-edit-mobilefeed',
  templateUrl: './edit-mobilefeed.component.html',
  styleUrls: ['./edit-mobilefeed.component.css']
})
export class EditMobilefeedComponent implements OnInit {
  public mobileFeedModel = new MobileFeedModel();
  public comboDtl = new ComboDetails();
  public oolDetails: KomFeed[] = [];
  public header: string = 'Edit Feed Data';
  public products: ComboDetails[] = [];
  public productInfo: ComboDetails[] = [];
  public IsmodelShow: boolean = false;
  public controlStr = new FormControl();

  public actions: any;
  public actionButtons: any;
  public buttons: Buttons[] = [];
  public filteredCommStrValues: Observable<ComboDetails[]> | undefined;
  public field: string;
  public ordersTableColumns: TableColumn[];
  public columnsData: any;
  public isStatus: string = "";
  public resHeadder: string = 'Mobile Feed Results';
  public multicombo: ComboDetails[] = [];
  public comboDtlAdd = new ComboDetails();
  public check: boolean = true;

  public existingOolCurrProducts: ComboDetails[] = [];
  public existingOolPrevProducts: ComboDetails[] = [];
  public existingPremCurrProducts: ComboDetails[] = [];
  public existingPremPrevProducts: ComboDetails[] = [];

  public translateMasterdata: MobileFeedModel[] = [];
  public mobileFeedDeviceTypeData: MobileFeedModel[] = [];
  public mobileFeedPortFlagData: MobileFeedModel[] = [];
  public mobileFeedRecTypeData: MobileFeedModel[] = [];

  constructor(private globalService: GlobalService, private komFeedService: KomFeedService, private commissionService: CommissionService,
    private notificationService: NotificationService, private router: Router, private httpService: HttpClient) { }

  ngOnInit(): void {
    console.log(this.commissionService.editMobileFeedModel);
    this.mobileFeedModel = this.commissionService.editMobileFeedModel[0];
    console.log(this.mobileFeedModel);
    this.isStatus = this.mobileFeedModel.status;
    console.log(this.isStatus);

    if (this.isStatus === "Update") {
      this.header = 'Edit Mobile Feed Data';
    } else if (this.isStatus === "Replicate") {
      this.header = 'Replicate Mobile Feed Data';
    }
    console.log(this.header);
    this.getTranslateData();
  }

  getTranslateData() {
    this.komFeedService.getAdminConfigData()
      .subscribe((data: any) => {
        this.translateMasterdata = data;
        console.log(this.translateMasterdata);
        this.getMobileFeedDeviceType();
        this.getMobileFeedPortFlag();
        this.getMobileFeedRecType();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getMobileFeedDeviceType() {
    const filterValue = this.globalService._normalizeValue('Mobile Feed Device Type');
    this.mobileFeedDeviceTypeData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.field_name).startsWith(filterValue));
    this.mobileFeedDeviceTypeData = this.mobileFeedDeviceTypeData.sort((a, b) => (a.field_value < b.field_value) ? -1 : 1);
    console.log(this.mobileFeedDeviceTypeData);
  }

  getMobileFeedPortFlag() {
    const filterValue = this.globalService._normalizeValue('Mobile Feed Port Flag');
    this.mobileFeedPortFlagData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.field_name).startsWith(filterValue));
    this.mobileFeedPortFlagData = this.mobileFeedPortFlagData.sort((a, b) => (a.field_value < b.field_value) ? -1 : 1);
  }

  getMobileFeedRecType() {
    const filterValue = this.globalService._normalizeValue('Mobile Feed Rec Type');
    this.mobileFeedRecTypeData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.field_name).startsWith(filterValue));
    this.mobileFeedRecTypeData = this.mobileFeedRecTypeData.sort((a, b) => (a.field_value < b.field_value) ? -1 : 1);
  }

  changeValue(event: any) {
    console.log(event.currentTarget.value);
    if (event.currentTarget.value === "C") {
      this.mobileFeedModel.total_count = -1;
    } else if (event.currentTarget.value === "R") {
      this.mobileFeedModel.total_count = 1;
    } else if (event.currentTarget.value === "1") {
      this.mobileFeedModel.trans_type = "R";
    } else if (event.currentTarget.value === "-1") {
      this.mobileFeedModel.trans_type = "C";
    }
  }

  public update() {
    console.log("update Called: " + JSON.stringify(this.mobileFeedModel));
    this.mobileFeedModel.last_modified_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.komFeedService.updateMobileFeedByID(this.mobileFeedModel).subscribe(
      (response: CustomHttpRespone) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      },
      (error: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, error.error.message);
      }
    )
  }

  Replicate() {
    console.log("Replicate Called");
    //this.mobileFeedModel.mobilefeedid = this.mobileFeedModel.mob_feed_id;
    //console.log(this.mobileFeedModel.mobilefeedid);
    // this.mobileFeedModel.mob_feed_id = 0;
    this.mobileFeedModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.mobileFeedModel.created_on = new Date();
    //console.log(this.mobileFeedModel);
    this.komFeedService.addMobileFeed(this.mobileFeedModel).subscribe(
      (response: MobileFeedModel) => {
        //console.log(response);
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Replicated Successfully");
        this.router.navigate(['/' + 'mobile-results']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public back() {
    this.router.navigate(['/mobile-results']);
  }

  public save(comboForm: NgForm) {
    this.update();
    // this.close(comboForm, 'closeAddKPIButton1');
    // this.close(comboForm, 'closeAddKPIButton2');
    // this.close(comboForm, 'closeAddKPIButton3');
    // this.close(comboForm, 'closeAddKPIButton4');
  }


  filterCommStr() {
    this.filteredCommStrValues = this.controlStr.valueChanges.pipe(
      startWith(''),
      map(value => this._filterStr(value))
    );
  }

  private _filterStr(value: string): ComboDetails[] {
    const filterValue = this._normalizeValue(value);
    return this.products.filter(item => this._normalizeValue(item.productName).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    return value.toString().toLowerCase().replace(/\s/g, '');
  }


  redirect() {
    this.router.navigate(['/adjustments-feed']);
  }

  close(kpiForm: NgForm, id: string) {
    this.multicombo = [];
    this.multicombo.push(this.comboDtlAdd);
    console.log("multicombo = " + this.multicombo);
    kpiForm.reset();
    document.getElementById(id).click();
  }

}

